module.exports = __webpack_public_path__ + "static/dusanstvo_omne-db67a9e2ae6ec5d6fb67d5c70e66ba63.jpg";